import { Typography } from 'antd';
import React from 'react';
const { Title } = Typography;


const ContactTitle = () => {
    return (
        <div style={{ backgroundColor: '#112240' }}>
            <div style={{ padding: '5rem 0', textAlign: 'center', }}>
                <Title level={3} style={{ color: '#fff', }}>Contact With Me</Title>
                <Title level={5} style={{ color: '#fff', textTransform: 'uppercase' }} >"It does not matter how slowly you go as long as you do not stop"</Title>
            </div>
        </div>
    );
};

export default ContactTitle;